export interface OptionsType {
	staticTickrate: number;
}

export const Options: OptionsType = {
	staticTickrate: 30,
};
